<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="@/assets/icons/zigatext-text.png"
          height="40"
          alt="Zigatext"
        />
        <img
          class="navbar-brand-minimized rounded"
          src="@/assets/icons/zigatext-white-icon.png"
          height="40"
          alt="Zigatext"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none custom-toggler" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <!--b-nav-form>
          <b-form-input class="mr-lg-4" type="search" placeholder="Search"></b-form-input>
        </b-nav-form-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderBadge />
        </b-nav-item>
        <!--b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownNotif/>
        </b-nav-item-->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!--AsideToggler class="d-none d-lg-block custom-toggler" />
      <AsideToggler class="d-lg-none" mobile /-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed class="bg-light">
        <SidebarHeader />
        <!--SidebarForm/-->
        <b-button
          variant="primary"
          @click="gotoCompose()"
          class="btn-pill mt-1 ml-1 mr-1 mb-1"
          ><i class="cui-note icons d-block"
            ><span class="md-down-none "> Compose SMS</span></i
          ></b-button
        >
        <b-button
          variant="primary"
          @click="gotoBuyUnits()"
          class="btn-pill mt-1 ml-1 mr-1 mb-1"
          ><i class="cui-credit-card icons d-block"
            ><span class="md-down-none ">
              Buy Units
            </span>
            <div style="font-weight: bold; text-align: center;">
              Balance: {{ Number(balances[0].balance).toLocaleString() }}
            </div>
          </i></b-button
        >

        <SidebarNav :navItems="nav" class="bg-light"></SidebarNav>
        <SidebarFooter />
        <div class="label pl-3 pb-2 text-secondary">Zigatext v1.0.0</div>
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <router-view></router-view>
      </main>
      <!--AppAside fixed>
        <DefaultAside/>
      </AppAside-->
    </div>
  </div>
</template>

<script>
import nav from '@/_nav';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import DefaultHeaderBadge from './DefaultHeaderBadge';
import { StorageService } from '@/services/storage.service';
import { mapGetters, mapActions } from 'vuex';
import router from '@/router/index';
import { EventBus } from '@/events/bus.event';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownAccnt,
    DefaultHeaderBadge,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      router: router,
    };
  },
  created() {
    this.fetchBalances();
    this.handleLogout();
    let interval = setInterval(() => {
      this.handleLogout();
    }, 10000);
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    ...mapGetters('user', ['user']),
    ...mapGetters('dashboard', ['balances']),
    nav() {
      return nav.items;
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('dashboard', ['fetchBalances']),
    handleLogout() {
      const logoutTime = new Date(
        StorageService.getItem('logoutTime')
      ).getTime();
      const currentTime = new Date().getTime();
      if (currentTime > logoutTime) {
        this.logout();
        document.body.classList.remove(
          'aside-menu-lg-show',
          'header-fixed',
          'sidebar-fixed'
        );
        window.location.reload();
      }
    },
    gotoCompose: function() {
      if (this.$route.path != '/message-box') {
        this.router.push({ path: '/message-box', query: { compose: true } });
      } else {
        EventBus.$emit('open-compose-sms');
      }
    },
    gotoBuyUnits: function() {
      if (this.$route.path != '/account/ziga-units') {
        this.router.push({ path: '/account/ziga-units' });
      }
    },
  },
};
</script>
